/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { sortBy } from 'lodash';
import {
  Typography,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Collapse,
} from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';

import Navigation from './Navigation';
import GreenButton from '../buttons/Green';
import { prepareOptions } from '../../shared_client_utils/formUtils';
import { moneytizeObjects } from '../../shared_client_utils/moneyUtils';
import Accordion, {
  AccordionSummary,
  AccordionDetails,
} from '../Accordion/Small';

const useStyles = makeStyles()(theme => ({
  main: {
    padding: theme.spacing(2, 2, 0, 2),
    backgroundColor: '#ffffff',
    // overflowY: 'auto',
  },
  formControlRoot: {
    width: '100%',
  },
  serviceBox: {
    flexDirection: 'column',
    marginBottom: theme.spacing(),
  },
  serviceLine: {
    display: 'grid',
    gridTemplateColumns: 'auto 24px',
  },
  formControlLabelRoot: {
    margin: theme.spacing(0, 2, 1, 0),
    alignItems: 'flex-start',
  },
  formControlLabelLabel: {
    width: '100%',
  },
  radioRoot: {
    paddingTop: '3px',
  },
  serviceDuration: {
    marginRight: theme.spacing(2),
  },
  checkboxLabel: {
    flexDirection: 'column',
  },
  serviceName: {
    fontSize: '18px',
    fontWeight: '500',
  },
  serviceInfo: {
    justifyContent: 'space-between',
  },
  infoIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(1 / 2),
    cursor: 'pointer',
  },
  serviceDescription: {
    backgroundColor: '#F2F2F2',
    padding: theme.spacing(),
  },
}));

const Service = (props) => {
  const {
    classes: parentClasses,
    serviceCategories,
    currentStep,
    stepsData,
  } = props;

  const {classes, cx} = useStyles();
  const currentStepData = currentStep.getData(stepsData);

  const [service, setService] = useState(() => ({ ...currentStepData }));

  const [expandedCategoryId, setExpandedCategoryId] = useState(currentStepData.serviceCategoryId);
  const handleChangeExpandedCategory = categoryId => () => {
    if (expandedCategoryId === categoryId) {
      return setExpandedCategoryId('');
    }

    setExpandedCategoryId(categoryId);
  }

  const [expandedServiceId, setExpandedServiceId] = useState('');
  const handleChangeExpandedService = serviceId => () => {
    if (expandedServiceId === serviceId) {
      return setExpandedServiceId('');
    }

    setExpandedServiceId(serviceId);
  }

  const handleNextStep = () => {
    const { handleDisplayFlashMessage, handleNextStep } = props
    if (!service.id) {
      handleDisplayFlashMessage('Select service', 'error');
      return;
    }

    const areValuesChanged = service.id !== currentStepData.id;
    const newStepData = {
      service: {
        ...currentStepData,
        ...service,
        serviceCategoryId: expandedCategoryId,
      },
    };
    handleNextStep(newStepData, areValuesChanged);
  }

  const preparedCategories = sortBy(prepareOptions(serviceCategories.byId), 'order')
    .map(category => ({
      ...category,
      services: sortBy(moneytizeObjects(category.services, 'price'), 'order'),
    }));

  return (
    <div className={parentClasses.gridNoHeight}>
      <Navigation {...props} />
      <main className={cx(parentClasses.main, classes.main)}>
        <Grid container>
          {preparedCategories.map(category => (
            <Accordion
              key={category.id}
              expanded={expandedCategoryId === category.id}
              onChange={handleChangeExpandedCategory(category.id)}
            >
              <AccordionSummary>
                <Typography variant="h6">{category.name}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <FormControl className={classes.formControlRoot}>
                  <RadioGroup
                    name="serviceId"
                    value={service.id}
                  >
                    {category.services.map(service => (
                      <Grid container className={classes.serviceBox} key={service.id}>
                        <div className={classes.serviceLine}>
                          <FormControlLabel
                            key={service.id}
                            name={service.name}
                            value={service.id}
                            onChange={() => setService(service)}
                            control={(
                              <Radio
                                color="primary"
                                classes={{
                                  root: classes.radioRoot,
                                }}
                                component="div"
                              />
                            )}
                            label={(
                              <Grid
                                container
                                className={classes.checkboxLabel}
                              >
                                <Grid item className={classes.serviceName}>
                                  {service.name}
                                </Grid>
                                <Grid container className={classes.serviceInfo}>
                                  <Grid item className={classes.serviceDuration}>
                                    {service.formattedDuration}
                                  </Grid>
                                  <Grid item>{service.priceMoney.toFormat()}</Grid>
                                </Grid>
                              </Grid>
                            )}
                            classes={{
                              root: classes.formControlLabelRoot,
                              label: classes.formControlLabelLabel,
                            }}
                          />
                          {service.description && (
                            <Grid container>
                              <InfoIcon
                                onClick={handleChangeExpandedService(service.id)}
                                className={classes.infoIcon}
                              />
                            </Grid>
                          )}
                        </div>
                        <Collapse in={expandedServiceId === service.id}>
                          <Grid item className={classes.serviceDescription}>
                            {service.description}
                          </Grid>
                        </Collapse>
                      </Grid>
                    ))}
                  </RadioGroup>
                </FormControl>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </main>

      <footer className={parentClasses.footer}>
        <GreenButton
          stretched
          variant="contained"
          size="large"
          onClick={handleNextStep}
          className={parentClasses.mainButton}
        >
          Next
        </GreenButton>
      </footer>
    </div>
  );
};

export default Service;
